/**
 * Canonical Shrike Text → Design System typography map (ENTUC-7722).
 *
 * Independent scales — do not invent names. Always pair type + foreground.
 * Source: `.claude/skills/shrike-text-to-ds-typography.md`
 */
export const textStyle = {
  heading900: 'text-heading-2',
  heading800: 'text-heading-3',
  heading700: 'text-heading-4',
  heading500: 'text-medium-body-medium',
  paragraph600: 'text-large-body-regular',
  paragraph500: 'text-medium-body-regular',
  paragraph400: 'text-small-body-regular',
  /** Shrike Text with no textStyle defaults to paragraph500 */
  default: 'text-medium-body-regular',

  /*
   * Surface-keyed, not Shrike-keyed: Figma overrides the mapping above on
   * these surfaces, so the same Shrike style resolves differently depending on
   * where it renders. Keep them here rather than inline so no call site has
   * to hand-write DS classes.
   */
  /** Dialog header. Shrike heading700, but Figma specifies 18px/600. */
  dialogTitle: 'text-heading-5',
  /** Avatar initial. Shrike heading800, but Figma specifies 24px/700, and
   * the DS scale tops out at 500 for this size. */
  tenantLetter: 'text-heading-3 font-bold',
  /** "What data is captured?" label. Figma mini/body/bold — 12px/600. */
  capturedDataLabel: 'text-mini-body-semibold',
} as const;

export const textColor = {
  primary: 'text-foreground-primary',
  secondary: 'text-foreground-secondary',
  inverse: 'text-foreground-inverse',
  info: 'text-foreground-info',
} as const;

export type TextStyleName = keyof typeof textStyle;
export type TextColorName = keyof typeof textColor;

export const ty = (style: TextStyleName, color: TextColorName = 'primary'): string =>
  `${textStyle[style]} ${textColor[color]}`;
